import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import VueApexCharts from 'vue-apexcharts'
import * as VueGoogleMaps from 'vue2-google-maps'
import moment from 'moment'
import request from '@utils/Request.js'
import VCalendar from 'v-calendar';
import VueSweetalert2 from 'vue-sweetalert2';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import Paginate from 'vuejs-paginate'
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en'
import VueRecaptcha from 'vue-recaptcha';
import { ProfileCheckerPlugin } from "./plugins/ProfileChecker";
import { LogOutPlugin } from "./plugins/LogOut";
/*
  Import the styles
*/
import './style/site.css';
import './style/google_maps.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import './style/button.css'
import './style/mobile.css'
import 'element-ui/lib/theme-chalk/index.css';
import { Auth0Plugin } from './auth';
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.prototype.$moment = moment;

const init = (keys) => {
  store.commit("setKeys", keys);
  // Vue.use(DisableAutocomplete)
  Vue.use(VueApexCharts)
  Vue.use(VCalendar)
  Vue.use(VueSweetalert2)
  Vue.use(BootstrapVue)
  Vue.use(IconsPlugin)
  Vue.use(ElementUI, {locale});
  Vue.use(VueGoogleMaps, {
    load: {
      key: keys['googleMapKey'],
      libraries: ['places, geometry', 'visualization']
    },
    installComponents: true
  })

  Vue.use(Auth0Plugin, {
    domain: "adway.us.auth0.com",
    clientId: keys.auth0ClientId,
    onRedirectCallback: appState => {
      router.push(
        appState && appState.targetUrl
          ? appState.targetUrl
          : window.location.pathname
      );
    }
  });
  Vue.use(ProfileCheckerPlugin);
  Vue.use(LogOutPlugin);
  Vue.component('apexchart', VueApexCharts)
  Vue.component('paginate', Paginate)
  Vue.component('vue-recaptcha', VueRecaptcha)

  Vue.mixin({
    methods: {
      customFormatter: date => moment(date).format('YYYY-MM-DD'),
      customUSFormatter: date => moment(date).format('MM-DD-YYYY'),
      customMonthFormatter: date => moment(date).format('LL'),
      request: async (url, method, body) => await request(url, method, body),
      isMobile: () => window.innerWidth < 600 ? true : false,
      isTablet: () => window.innerWidth > 600 &&  window.innerWidth < 1024? true : false,
      isDebug: () => window.location.href.includes('localhost') || window.location.href.includes('192.') ? true : false,
    }
  })

  Vue.config.productionTip = false

  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app');
}

fetch("/keys.json")
  .then((response) => {
    if (!response.ok) throw new Error(`Status:  ${response.status}. ${response.statusText}`);
    return response.json();
  })
  .then(init)
  .catch((error) => {
      console.error("Keys fetching error: ", error.message);
    init({});
  });
